import { useEffect, useRef } from 'react';
import { useAuth } from '../hooks/useAuth';

declare global {
  interface Window {
    onTelegramAuth?: (user: Record<string, unknown>) => void;
  }
}

export function TelegramLoginButton({
  botUsername,
  onError,
}: {
  botUsername: string;
  onError?: (msg: string) => void;
}) {
  const { login } = useAuth();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!botUsername || !ref.current) return;
    window.onTelegramAuth = async (user) => {
      const ok = await login(user);
      if (!ok) onError?.('Ошибка входа через Telegram');
    };
    ref.current.innerHTML = '';
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.async = true;
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '8');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    ref.current.appendChild(script);
    return () => {
      delete window.onTelegramAuth;
    };
  }, [botUsername, login, onError]);

  if (!botUsername) {
    return <p className="error-text">BOT_USERNAME не настроен на сервере API</p>;
  }
  return <div ref={ref} />;
}
